import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import moment from "moment";

function NovelChaps({ currentChapters, currentNovel }) {
  const today = moment();
  const { id } = useParams();
  const [loadingMore, setloadingMore] = useState(false);
  const [loadingChaps, setLoadingChaps] = useState(10);

  useEffect(() => {
    let arr =
      currentChapters?.chapters &&
      currentChapters?.chapters?.map((chap, index) => {
        return index + 1;
      });
    const result = [];
    const result2 = [];
    if (arr) {
      for (let i = 0; i < arr.length; i += 2) {
        result.push(arr.slice(i, i + 2));
      }
      for (let j = 0; j < arr.length; j += 2) {
        result2.push(result[j]);
      }
    }

    const chapters = result2.toString().split(/[\s,]+/);
    // eslint-disable-next-line array-callback-return
    chapters.map((chap) => {
      const chapter = document.querySelector(
        `.chapters > div:nth-child(${chap}n)`
      );
      if (chapter) {
        chapter.classList.add("chap-color-changer");
      }
    });
  }, [loadingChaps, currentChapters?.chapters]);
  useEffect(() => {
    if (loadingChaps >= currentChapters?.chapters?.length) {
      setloadingMore(true);
    }
  }, [loadingChaps]);
  const noChapters = (
    <div className="my-[180px] sm:my-[150px]">
      <div className="relative flex justify-center items-center w-fit m-auto">
        <h2 title="Coming soon" className="font-size text-tertiary">
          NO CHAPTERS
          <span className="absolute font-Cclassic capitalize font-size-stylish text-primary">
            Soon
          </span>
        </h2>
      </div>
    </div>
  );
  return (
    <div className="sm:mt-[100px] mt-[100px]  px-[15px] md:px-0">
      <div className="relative flex flex-col gap-y-4 text-center sm:text-left sm:flex-row justify-between items-center">
        <div>
          <h2 className="font-size text-tertiary">Latest Chapters</h2>
        </div>
      </div>
      <div>
        {currentChapters?.pending === false &&
          currentChapters?.chapters?.length > 0 && (
            <div className="chapters py-[50px] sm:py-[60px] grid grid-cols-1 md:grid-cols-2 gap-x-4 md:gap-x-10 lg:gap-x-20  w-full max-w-[1200px] m-auto">
              {currentChapters?.chapters
                ?.slice(0, loadingChaps)
                .map((chapter, index) => {
                  return (
                    <div title={chapter.chapterName} key={chapter._id}>
                      <Link to={`/novels/${id}/${chapter._id}`}>
                        <div className="border-b-[1px] cursor-pointer group hover:bg-primary duration-500 ease-in-out border-tertiary text-tertiary flex justify-start h-[100px] relative place-items-center w-full pl-6 sm:pl-10 gap-x-6 sm:gap-x-10">
                          <div className="text-[16px] md:text-[20px]">
                            <h1>{currentChapters?.chapters.length - index}</h1>
                          </div>
                          <div className="flex flex-col w-full">
                            <div className="flex justify-between items-center">
                              <h2 className="break-all text-[14px] md:text-[16px] line-clamp-1 pr-8">
                                Chapter{" "}
                                {currentChapters?.chapters.length - index
                                  ? currentChapters?.chapters.length - index <
                                    10
                                    ? "00" +
                                      (currentChapters?.chapters.length - index)
                                    : currentChapters?.chapters.length - index >
                                      99
                                    ? currentChapters?.chapters.length - index
                                    : "0" +
                                      (currentChapters?.chapters.length - index)
                                  : "000"}
                                :{"   "} {chapter.chapterName}
                              </h2>
                              {today.diff(moment(chapter.createdAt), "hours") <
                                24 && (
                                <div className="text-[12px] md:text-[13px] text-primary group-hover:text-tertiary duration-500 ease-in-out pr-4 md:pr-8">
                                  NEW
                                </div>
                              )}
                            </div>
                            <h5 className="text-tertiary/70 text-[13px] md:text-[14px]">
                              {moment(chapter.createdAt).fromNow()}
                            </h5>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })}
            </div>
          )}
        {(currentChapters?.pending === true ||
          currentNovel?.pending === true) && (
          <div className="py-[150px]  sm:py-[200px]">
            <div
              className=" scale-125 flex w-fit justify-center items-center text-center m-auto "
              role="status"
            >
              <svg
                aria-hidden="true"
                className="mr-2 w-8 h-8 text-gray-600 animate-spin  fill-primary"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {!loadingMore &&
          currentChapters?.pending === false &&
          currentChapters?.chapters.length !== 0 && (
            <div className="flex justify-center pb-[50px] sm:pb-0">
              <button
                title="Load More"
                onClick={() => {
                  setLoadingChaps((prev) => prev + 30);
                }}
                className="z-50 text-tertiary capitalize Purple-btn-effect relative bg-primary h-[52px] w-fit px-8 "
              >
                Load more
              </button>
            </div>
          )}
        {currentChapters?.pending === false &&
          currentChapters?.chapters?.length === 0 && <div>{noChapters}</div>}
      </div>
    </div>
  );
}

export default NovelChaps;
